import { EmptyState } from "@/components/molecules";

export const OffloadDriversEmptyState = ({ hasFilters }: { hasFilters?: boolean; }) => (
  <EmptyState 
    title="Offload Drivers" 
    description={hasFilters ? "There are no drivers matching your filter criteria at the moment." : "There are currently no offload drivers available. Network drivers you've assigned tasks to will appear here once they've completed the job."} 
  />
);
